import { RouteProps } from 'react-router-dom'

import { PermissionRequirement, PermissionRoute } from '@cbgms/base/permissions/permissionsUtils'

import { useHasPermission } from './RequiredPermissions'

interface Props<Path extends string> extends RouteProps<Path> {
  permission: PermissionRequirement
}

/**
 * If the user matches permission requirement it will render the route, otherwise it will redirect to a 404 page
 */
function RolePermissionRoute<Path extends string>(props: Props<Path>) {
  const { permission } = props
  const [hasPermission] = useHasPermission(permission)

  return <PermissionRoute {...props} hasPermission={hasPermission} unauthorizedRedirectURL='/401' />
}

export default RolePermissionRoute
